<div class="progress-stepper-container">
  @for (step of steps(); track step) {
    <lib-progress-label [titleText]="step"
                        [stepNumber]="$index + 1"
                        [state]="ProgressStepperComponent.state($index + 1, currentStep())"
                        [size]="size()"/>
  }
</div>
